import { render } from "./FormHomeHeader.vue?vue&type=template&id=2012b594&scoped=true"
import script from "./FormHomeHeader.vue?vue&type=script&lang=js"
export * from "./FormHomeHeader.vue?vue&type=script&lang=js"

import "./FormHomeHeader.vue?vue&type=style&index=0&id=2012b594&scoped=true&lang=css"

import exportComponent from "/Users/rs/Development/alisops/osod-form/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2012b594"]])

export default __exports__